module.exports = __webpack_public_path__ + "static/media/anemo.6d4ab85d.jpg";